var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "复制订单规则",
            visible: _vm.copyOrderRuleDialog,
            "append-to-body": "",
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.copyOrderRuleDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formOrder",
              staticClass: "myForm",
              attrs: { inline: "", model: _vm.formOrder },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "复制订单号",
                    prop: "from_order_id",
                    rules: [
                      {
                        required: true,
                        message: "请输入正确的订单号",
                        trigger: "change",
                      },
                      { pattern: /^([0-9]*)$/, message: "请输入正整数！" },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "请输入内容" },
                    model: {
                      value: _vm.formOrder.from_order_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.formOrder, "from_order_id", $$v)
                      },
                      expression: "formOrder.from_order_id",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticStyle: { color: "#909399" } }, [
                _vm._v(
                  " 提交后将按照填写的订单号对应的功能菜单覆盖到本订单（包括子菜单、所有黑名单、白名单） "
                ),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium", plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.copyOrderRuleDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.saveCopyOrderRule },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }